import React, { useState, useEffect } from 'react';
import { TabBar } from 'antd-mobile';
import { RobotOutlined, AppstoreOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';

const BottomNavBar = () => {
  const [activeKey, setActiveKey] = useState('chat');
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === '/suggestions') {
      setActiveKey('suggestions');
    } else {
      setActiveKey('chat');
    }
  }, [location.pathname]);
  const tabs = [
    {
      key: 'chat',
      title: 'Chat',
      icon: <RobotOutlined />,
    },
    {
      key: 'suggestions',
      title: 'Suggestions',
      icon: <AppstoreOutlined />,
    },
  ];

  return (
    <div style={{ width: '100%', height: '6vh' }}>
      <TabBar
        activeKey={activeKey}
        onChange={(e) => {
          if (e === 'suggestions') {
            navigate('/suggestions');
          } else {
            navigate('/');
          }
          setActiveKey(e);
        }}
      >
        {tabs.map((item) => (
          <TabBar.Item key={item.key} icon={item.icon} title={item.title} />
        ))}
      </TabBar>
    </div>
  );
};

export default BottomNavBar;
